import { Fragment, h } from "preact";

import { CloseIcon, CaretIcon, FilterIcon } from "../icons.jsx";
import { useState, useEffect, useRef } from "preact/hooks";
import FilterList from "./filter-list.jsx";

const sortOptions = [
  {
    key: "sort_collection_default",
    label: "Featured",
    value: "COLLECTION_DEFAULT",
    reverse: false,
  },
  {
    key: "sort_price_low_high",
    label: "Price (low to high)",
    value: "PRICE",
    reverse: false,
  },
  {
    key: "sort_price_high_low",
    label: "Price (high to low)",
    value: "PRICE",
    reverse: true,
  },
  {
    key: "sort_best_selling",
    label: "Best Seller",
    value: "BEST_SELLING",
    reverse: false,
  },
];
const ProductFilterSort = ({
  allFilters,
  clearAllFilters,
  applyFilterSort,
  handleDrawer,
  toggleFilterOption,
  totalProductsCount,
  sortOption,
  setSortOption,
  open,
}) => {
  const [sortHeading, setSortHeading] = useState("Sort by");
  const [filterHeading, setFilterHeading] = useState("Filter by");
  const drawerRef = useRef(null);
  const drawerToggleRef = useRef(null);
  const [focusTrapped, setFocusTrapped] = useState(false);

  if (open) {
    if (!focusTrapped && drawerRef.current) {
      window.trapFocus(
        drawerRef.current,
        drawerRef.current.querySelector("[data-close]"),
      );
      setFocusTrapped(true);
    }
  } else {
    if (focusTrapped) {
      window.removeTrapFocus(drawerToggleRef?.current);
      setFocusTrapped(false);
    }
  }

  const handleClearFilter = () => {
    allFilters.forEach((filterList) => {
      filterList.values.forEach((filter) => {
        filter.isChecked = false;
      });
    });

    clearAllFilters(allFilters);
  };

  return (
    <Fragment>
      <button
        className="collection-drawer__toggle button-text"
        onClick={(event) => handleDrawer(event)}
        data-target="collection-filter"
        ref={drawerToggleRef}
      >
        <FilterIcon />
        <span>Filter & Sort</span>
      </button>
      <div
        className={`collection-drawer collection-drawer--filter ${open}`}
        data-collection-drawer
        data-collection-filter
        data-collection-sort
        style={{ display: open ? null : "none" }}
        ref={drawerRef}
      >
        <div
          className={`collection-drawer__overlay ${open}`}
          onClick={(event) => handleDrawer(event)}
          data-target="collection-filter"
        ></div>
        <div className="collection-drawer__container">
          <div className="collection-drawer__content-wrapper">
            <button
              className="collection-drawer__close"
              onClick={(event) => handleDrawer(event)}
              data-target="collection-filter"
              data-close
            >
              <span className="visually-hidden">Close</span>
              <CloseIcon />
            </button>
            <div className="collection-drawer__header ">
              <h5 className="eyebrow">{filterHeading}</h5>
              <div className="">
                <button
                  className="link text-small "
                  onClick={handleClearFilter}
                >
                  Clear
                </button>
              </div>
            </div>
            <div className="collection-drawer__content">
              {allFilters.map((filterList) => (
                <FilterList
                  filterList={filterList}
                  toggleFilterOption={toggleFilterOption}
                />
              ))}
            </div>
            <div className="collection-drawer__header ">
              <h5 className="eyebrow">{sortHeading}</h5>
            </div>
            <div className="collection-drawer__content">
              <div className="collection-drawer__options">
                {sortOptions.map((item, index) => (
                  <div class="collection-drawer__option radiobox" index={index}>
                    <input
                      type="radio"
                      name="collection-sort"
                      id={item.key}
                      reverse={item.reverse}
                      onChange={(event) => {
                        event.stopPropagation();
                        setSortOption(item);
                        applyFilterSort(event);
                      }}
                      checked={
                        item.value === sortOption.value &&
                        item.reverse === sortOption.reverse
                      }
                    />
                    <label className="text" htmlFor={item.key}>
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="collection-drawer__footer">
            <button
              className="button button--secondary"
              onClick={(event) => handleDrawer(event)}
              data-target="collection-filter"
            >
              Show {totalProductsCount} Products
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductFilterSort;
